import React, { useState, useEffect, useContext } from "react";
import {
  cargarTipoProducto,
} from "../services/productos.jsx";
import Context from "../context/CartContext.jsx";
import ContextProveedor from "../context/ProveedorContext";
import { cargaProveedorUnico } from "../services/proveedores.jsx";

export default function BuscadorCbo(props) {
  const { data, proveedor } = props;
  const { cart, setCart } = useContext(Context);
  const { setProveedorContext } = useContext(ContextProveedor);
  const [busqueda, setBusqueda] = useState("");
  const [productosFiltrados, setProductosFiltrados] = useState(data);
  const [chkBusqueda, setChkBusqueda] = useState("option1");
  const [ordenLetras, setOrdenLetras] = useState("XX");
  const [cboTipoProducto, setCboTipoProducto] = useState([]);
  const [tipoProducto, setTipoProducto] = useState(0);
  const [medidas, setMedidas] = useState([]);
  const [medidasSeleccionada, setMedidasSeleccionadas] = useState("XX");
  const [productos, setProductos] = useState(data);

  useEffect(() => {
    cargarTipoProducto()
      .then((tipo_producto) => setCboTipoProducto(tipo_producto))
      .catch((error) => console.error(error));
    cargaProveedorUnico(proveedor)
      .then((prov) => setProveedorContext(prov))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    setProductos((prev) =>
      prev.map((p) => {
        const itemEnCarrito = cart.find((c) => c.id_producto === p.id_producto);
        return { ...p, cantidad: itemEnCarrito ? itemEnCarrito.cantidad : 0 };
      })
    );
  }, [cart]);

  useEffect(() => {
    const mapaMedidas = new Map();
    data.forEach((p) => {
      if (p.unidad_medida && !mapaMedidas.has(p.unidad_medida)) {
        mapaMedidas.set(p.unidad_medida, { id: p.unidad_medida, numeracion: p.numeracion, nombre: p.medidaOficial });
      }
    });
    setMedidas(Array.from(mapaMedidas.values()));
  }, [data]);

  useEffect(() => {
    let filtered = [...productos];

    if (tipoProducto !== 0) {
      filtered = filtered.filter((p) => p.tipo_producto === Number(tipoProducto));
    }

    if (medidasSeleccionada !== "XX") {
      filtered = filtered.filter((p) => p.unidad_medida === Number(medidasSeleccionada));
    }

    if (chkBusqueda === "option1") {
      filtered = filtered.filter((p) =>
        p.producto_nombre.toLowerCase().startsWith(busqueda.toLowerCase())
      );
    } else {
      filtered = filtered.filter((p) =>
        p.producto_nombre.toLowerCase().includes(busqueda.toLowerCase())
      );
    }

    if (ordenLetras === "DESC") {
      filtered.sort((a, b) => a.producto_nombre.localeCompare(b.producto_nombre));
    } else if (ordenLetras === "ASC") {
      filtered.sort((a, b) => b.producto_nombre.localeCompare(a.producto_nombre));
    }

    setProductosFiltrados(filtered);
  }, [chkBusqueda, busqueda, productos, ordenLetras, tipoProducto, medidasSeleccionada]);

  const manejarCantidad = (productoId, operacion, nuevaCantidad) => {
    const nuevosProductos = [...productos];
    const productoIndex = nuevosProductos.findIndex(
      (p) => p.id_producto === productoId
    );

    if (productoIndex !== -1) {
      const producto = nuevosProductos[productoIndex];

      if (operacion === "incrementar") {
        producto.cantidad = (producto.cantidad || 0) + 1;
      } else if (operacion === "decrementar" && producto.cantidad > 0) {
        producto.cantidad -= 1;
      } else if (operacion === "editar") {
        const cantidadNumerica = parseInt(nuevaCantidad, 10);
        if (!isNaN(cantidadNumerica)) {
          producto.cantidad = Math.max(0, cantidadNumerica);
        }
      } else if (operacion === "vaciar") {
        producto.cantidad = 0;
      }
      const productosEnCarrito = nuevosProductos.filter(
        (p) => p.cantidad !== 0
      );
      setCart(productosEnCarrito);
    }
  };

  return (
    <div className="space-y-4">
      <div className="card p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
          <div>
            <label className="label-field">Ordenar Por:</label>
            <select
              onChange={(e) => setOrdenLetras(e.target.value)}
              className="select-field text-sm"
            >
              <option value="XX">Ordenar por Letras</option>
              <option value="DESC">A {"→"} Z</option>
              <option value="ASC">Z {"→"} A</option>
            </select>
          </div>

          <div>
            <label className="label-field">Por Medida:</label>
            <select
              onChange={(e) => setMedidasSeleccionadas(e.target.value)}
              className="select-field text-sm"
            >
              <option value="XX">Todas las medidas</option>
              {medidas.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.numeracion + " " + m.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <label className="label-field">Buscar Producto:</label>
            <div className="relative">
              <input
                type="text"
                className="input-field pl-9 text-sm"
                placeholder="Buscar..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
              <svg className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>

          <div>
            <label className="label-field">Busqueda:</label>
            <div className="flex gap-2">
              <label className="flex items-center gap-1.5 cursor-pointer">
                <input
                  type="radio"
                  name="busqueda"
                  value="option1"
                  checked={chkBusqueda === "option1"}
                  onChange={(e) => setChkBusqueda(e.target.value)}
                  className="w-4 h-4 text-pons-500 border-surface-border focus:ring-pons-400"
                />
                <span className="text-sm text-ink-muted">Inicial</span>
              </label>
              <label className="flex items-center gap-1.5 cursor-pointer">
                <input
                  type="radio"
                  name="busqueda"
                  value="option2"
                  checked={chkBusqueda === "option2"}
                  onChange={(e) => setChkBusqueda(e.target.value)}
                  className="w-4 h-4 text-pons-500 border-surface-border focus:ring-pons-400"
                />
                <span className="text-sm text-ink-muted">Incluida</span>
              </label>
            </div>
          </div>

          <div>
            <label className="label-field">Mostrar Tipo:</label>
            <select
              onChange={(e) => setTipoProducto(Number(e.target.value))}
              className="select-field text-sm"
            >
              <option value="0">Todos</option>
              {cboTipoProducto.map((element) => (
                <option key={element.id} value={element.id}>
                  {element.nombre}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {productosFiltrados.length === 0 ? (
        <div className="card p-8 text-center">
          <p className="text-ink-muted font-medium">No Hay Productos</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {productosFiltrados.map((element) => (
            <div
              key={element.id_producto}
              className="card-hover overflow-hidden flex flex-col"
            >
              <div className="relative bg-white p-4 flex items-center justify-center h-48">
                <img
                  src={
                    "https://storage.googleapis.com/imagenes-ponsrazas/" +
                    element.imagen
                  }
                  alt={element.producto_nombre}
                  className="max-h-full object-contain"
                />
                {element.cantidad > 0 && (
                  <>
                    <button
                      className="absolute top-2 left-2 bg-danger/90 hover:bg-danger text-white rounded-full w-7 h-7 flex items-center justify-center shadow-soft transition-all duration-200"
                      onClick={() => manejarCantidad(element.id_producto, "vaciar")}
                      title="Vaciar cantidad"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                    <span className="absolute top-2 right-2 bg-pons-500 text-white text-xs font-bold rounded-full w-7 h-7 flex items-center justify-center shadow-soft">
                      {element.cantidad}
                    </span>
                  </>
                )}
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h5 className="text-sm font-bold text-ink leading-tight mb-1">
                  {element.producto_nombre} {element.numeracion} {element.medidaOficial}
                </h5>
                <p className="text-xs text-ink-muted mb-3">{element.marca_nombre}</p>

                <div className="mt-auto flex items-center gap-2">
                  <button
                    className="w-9 h-9 rounded-full bg-danger/10 text-danger hover:bg-danger hover:text-white font-bold text-lg flex items-center justify-center transition-all duration-200 flex-shrink-0"
                    onClick={() => manejarCantidad(element.id_producto, "decrementar")}
                  >
                    −
                  </button>

                  <input
                    type="number"
                    className="flex-1 text-center input-field py-1.5 text-sm font-semibold rounded-lg"
                    value={element.cantidad !== undefined ? element.cantidad : ""}
                    onChange={(e) =>
                      manejarCantidad(
                        element.id_producto,
                        "editar",
                        parseInt(e.target.value, 10) || 0
                      )
                    }
                  />

                  <button
                    className="w-9 h-9 rounded-full bg-success/10 text-success hover:bg-success hover:text-white font-bold text-lg flex items-center justify-center transition-all duration-200 flex-shrink-0"
                    onClick={() => manejarCantidad(element.id_producto, "incrementar")}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
